import React from 'react';
import {
  Box, Container, Grid, Typography, Card, CardContent,
  Button, List, ListItem, ListItemIcon, ListItemText, Divider,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PageHero from '../components/PageHero';
import { Link } from 'react-router-dom';

function ServiceItem({ title, desc, items, icon, color = '#1a4d2e' }) {
  return (
    <Box sx={{
      p: 4, background: '#ffffff', borderRadius: 3,
      border: '1px solid rgba(0,0,0,0.06)',
      mb: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
    }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Box sx={{
          width: 44, height: 44, borderRadius: 2,
          background: `${color}15`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: '1.4rem',
        }}>
          {icon}
        </Box>
        <Typography variant="h6" sx={{ color: '#1a1a1a', fontSize: '1.05rem' }}>
          {title}
        </Typography>
      </Box>
      {desc && <Typography variant="body2" sx={{ color: '#718096', mb: 2 }}>{desc}</Typography>}
      {items && (
        <List dense disablePadding>
          {items.map((item, i) => (
            <ListItem key={i} disableGutters sx={{ py: 0.4 }}>
              <ListItemIcon sx={{ minWidth: 28 }}>
                <CheckCircleOutlineIcon sx={{ fontSize: 16, color }} />
              </ListItemIcon>
              <ListItemText
                primary={item}
                primaryTypographyProps={{ sx: { fontSize: '0.85rem', color: '#4a5568' } }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
}

export function BienesServicios() {
  return (
    <Box>
      <PageHero
        title="Bienes & Servicios"
        subtitle="Un portafolio completo para el fortalecimiento del sector agroindustrial."
        breadcrumbs={[{ label: 'Bienes y Servicios' }]}
      />
      <Box sx={{ py: { xs: 8, md: 14 }, background: '#f8f5ef' }}>
        <Container maxWidth="xl">
          <Grid container spacing={6}>
            <Grid item xs={12} md={6}>
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Emprendimiento</Typography>
              <ServiceItem
                icon="🚀"
                title="Gestión de Emprendimiento y Formulación de Proyectos"
                items={[
                  'Formulación e implementación de políticas de producción limpias',
                  'Sensibilización en mentalidad empresarial',
                  'Formulación de planes de negocio o proyectos',
                  'Creación de unidades productivas',
                  'Acompañamiento a las unidades productivas',
                  'Seguimiento a los apoyos económicos en Fortalecimiento',
                  'Presentación de proyectos a convocatorias',
                ]}
              />
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Desarrollo</Typography>
              <ServiceItem
                icon="🏗️"
                title="Proyectos de Desarrollo Agroindustrial"
                items={[
                  'Apalancamientos y cofinanciación con Alcaldías y Gobernaciones',
                  'Acompañamiento para presentación a convocatorias de fortalecimiento empresarial',
                  'Cooperación en adquisición de maquinaria al sector público',
                  'Consecución de recursos',
                  'Mejoramiento genético',
                ]}
              />
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Conocimiento</Typography>
              <ServiceItem
                icon="📚"
                title="Gestión del Conocimiento de Procesos"
                items={[
                  'Gerencia del conocimiento — Ciclo PHVA (Planear-Hacer-Verificar-Actuar)',
                  'Potenciación del Know How',
                  'Administración de la información',
                  'Administración de procesos productivos',
                  'Gestión de procesos administrativos',
                ]}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Empresarial</Typography>
              <ServiceItem
                icon="💼"
                title="Fortalecimiento Socio-Empresarial"
                items={[
                  'Sesiones de consultoría personalizada y especializada',
                  'Servicios de consultoría de negocios en economía solidaria',
                  'Gestión del conocimiento empresarial solidario',
                  'Gerencia agro-Industrial',
                ]}
              />
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Legal</Typography>
              <ServiceItem
                icon="⚖️"
                title="Asesoría Jurídica Organizacional"
                items={[
                  'Asesoría para procesos de Contratación',
                  'Asesoría en la Constitución de sociedades',
                  'Trámites en el Registro Mercantil',
                  'Modificaciones estatutarias',
                  'Consultoría en Patentes y marcas',
                ]}
              />
              <Typography variant="overline" sx={{ color: '#1a4d2e', mb: 1, display: 'block' }}>Digital</Typography>
              <ServiceItem
                icon="📱"
                title="Marketing y Comercio Digital"
                items={[
                  'Investigación de mercados e inteligencia competitiva',
                  'Plan de marketing y marketing mix',
                  'Diseño e implementación de CRM',
                  'Vigilancia tecnológica y Branding',
                  'Marketing digital y medición de ROI',
                ]}
              />
              <ServiceItem
                icon="💻"
                title="Asesoría TIC"
                items={[
                  'Herramientas corporativas y Cyber Gerencia',
                  'Business Intelligence y Sistemas ERP',
                  'Seguridad Informática y E-Commerce',
                  'Telecomunicaciones y Movilidad',
                  'Software Colaborativo (SBDC)',
                ]}
              />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}

function SimpleServicePage({ title, subtitle, breadcrumb, bgColor, sections }) {
  return (
    <Box>
      <PageHero title={title} subtitle={subtitle} breadcrumbs={[{ label: 'Bienes y Servicios', path: '/bienes-servicios' }, { label: breadcrumb }]} bgColor={bgColor} />
      <Box sx={{ py: { xs: 8, md: 14 }, background: '#f8f5ef' }}>
        <Container maxWidth="lg">
          {sections.map((s, i) => (
            <Box key={i} sx={{ mb: 5 }}>
              {s.title && <Typography variant="h4" sx={{ mb: 2, color: '#1a1a1a', fontSize: { xs: '1.5rem', md: '2rem' } }}>{s.title}</Typography>}
              {s.text && <Typography variant="body1" sx={{ color: '#4a5568', mb: 3, lineHeight: 1.85 }}>{s.text}</Typography>}
              {s.items && (
                <Grid container spacing={2}>
                  {s.items.map((item, j) => (
                    <Grid item xs={12} sm={6} key={j}>
                      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start', p: 2, background: '#fff', borderRadius: 2, border: '1px solid rgba(0,0,0,0.06)' }}>
                        <CheckCircleOutlineIcon sx={{ color: bgColor || '#1a4d2e', fontSize: 18, mt: 0.3, flexShrink: 0 }} />
                        <Typography variant="body2" sx={{ color: '#4a5568' }}>{item}</Typography>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              )}
              {i < sections.length - 1 && <Divider sx={{ mt: 4 }} />}
            </Box>
          ))}
          <Box sx={{ mt: 6, textAlign: 'center' }}>
            <Button variant="contained" color="primary" component={Link} to="/contacto" endIcon={<ArrowForwardIcon />} size="large">
              Solicitar Información
            </Button>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}

export function EscuelasAgroindustriales() {
  return <SimpleServicePage
    title="Escuelas Agroindustriales"
    subtitle="Formación especializada para emprendedores del campo colombiano."
    breadcrumb="Escuelas Agroindustriales"
    bgColor="#1a4d2e"
    sections={[
      { title: 'Programa de Formación Agroindustrial', text: 'Nuestras Escuelas de Emprendimiento Agro-industrial APL ofrecen formación integral para productores, transformadores y comercializadores del sector agropecuario colombiano, combinando teoría y práctica en contextos rurales reales.' },
      { items: ['Producción orgánica y limpia (BPA)', 'Protocolos ICA e INVIMA', 'Acuerdos de Producción Limpia APL', 'Transformación agroindustrial', 'Exportación de productos orgánicos', 'Asociatividad empresarial', 'Gestión financiera rural', 'Tecnologías aplicadas al agro'] },
    ]}
  />;
}

export function RedesEmpresariales() {
  return <SimpleServicePage
    title="Redes Empresariales"
    subtitle="Conectando actores del sector solidario para potenciar resultados colectivos."
    breadcrumb="Redes Empresariales"
    bgColor="#2d5a1a"
    sections={[
      { title: '¿Qué son las Redes Empresariales Solidarias?', text: 'Las Redes Empresariales son la columna vertebral de FENAGRO APL. Articulan a los asociados de primer y segundo nivel, creando un ecosistema donde las fortalezas individuales se convierten en ventajas colectivas para competir en mercados más exigentes.' },
      { items: ['Articulación de actores productivos', 'Acceso compartido a mercados', 'Economía colaborativa', 'Reducción de costos operativos', 'Transferencia de conocimientos', 'Gestión de convocatorias colectivas', 'Alianzas público-privadas', 'Fortalecimiento del tejido empresarial'] },
    ]}
  />;
}

export function BancoProyectos() {
  return <SimpleServicePage
    title="Banco de Proyectos"
    subtitle="Recursos, financiación y acompañamiento para materializar sus ideas agroindustriales."
    breadcrumb="Banco de Proyectos"
    bgColor="#1a3d4d"
    sections={[
      { title: 'Financiación para el Campo', text: 'El Banco de Proyectos Agroindustrial de FENAGRO APL conecta iniciativas productivas con fuentes de financiamiento públicas y privadas, garantizando el acompañamiento técnico necesario para la ejecución exitosa de cada proyecto.' },
      { items: ['Formulación de proyectos productivos', 'Cofinanciación con entidades públicas', 'Acceso a convocatorias de fomento', 'Cooperación internacional', 'Capital semilla para emprendimientos', 'Créditos y microcréditos solidarios', 'Gestión de recursos de cooperación', 'Mejoramiento genético y tecnológico'] },
    ]}
  />;
}

export function MercadoAsegurado() {
  return <SimpleServicePage
    title="Mercado Asegurado"
    subtitle="Garantice la venta de su producción antes de sembrar. Comercialización con equidad."
    breadcrumb="Mercado Asegurado"
    bgColor="#4d2e1a"
    sections={[
      { title: 'Comercialización Directa y Justa', text: 'El modelo de Mercado Asegurado de FENAGRO elimina la intermediación abusiva, conectando directamente a productores con compradores institucionales y consumidores finales, garantizando precios justos para todos los actores de la cadena productiva.' },
      { items: ['Acuerdos previos de compra-venta', 'Agro-tiendas orgánicas', 'Acceso a mercados internacionales', 'Productos con certificación BPA', 'Canales de distribución directa', 'Exportación de productos orgánicos', 'Precio justo para productores', 'Cadena de valor transparente'] },
    ]}
  />;
}

export function BancoInnovacion() {
  return <SimpleServicePage
    title="Banco de Innovación Tecnológica"
    subtitle="Tecnología al servicio del campo colombiano para mayor competitividad."
    breadcrumb="Banco de Innovación"
    bgColor="#1a2e4d"
    sections={[
      { title: 'Tecnología para el Agro', text: 'El Banco de Innovación Tecnológica de FENAGRO APL pone a disposición de los asociados las herramientas tecnológicas más avanzadas del sector agroindustrial, desde maquinaria compartida hasta plataformas digitales de gestión.' },
      { items: ['Acceso a maquinaria especializada', 'Plataformas de gestión productiva', 'Sistemas de información agropecuaria', 'Tecnologías de riego y postcosecha', 'Mejoramiento genético animal y vegetal', 'Trazabilidad de productos', 'Herramientas de inteligencia de mercados', 'Automatización de procesos'] },
    ]}
  />;
}

export function BancoEmprendimiento() {
  return <SimpleServicePage
    title="Banco de Emprendimiento"
    subtitle="El apoyo financiero y técnico que su emprendimiento necesita para crecer."
    breadcrumb="Banco de Emprendimiento"
    bgColor="#3d1a4d"
    sections={[
      { title: 'Impulso a Nuevos Negocios', text: 'El Banco de Emprendimiento Agroindustrial de FENAGRO APL es el motor de creación de nuevas empresas en el sector rural. Ofrece recursos financieros, mentoría especializada y acceso a redes de apoyo para transformar ideas en negocios sostenibles.' },
      { items: ['Financiación de capital semilla', 'Mentoría personalizada de expertos', 'Acceso a incubadoras y aceleradoras', 'Vinculación con inversionistas ángel', 'Programas de formación empresarial', 'Registro y formalización de empresas', 'Marca colectiva y denominación de origen', 'Conexión con fondos de emprendimiento'] },
    ]}
  />;
}
